document.addEventListener('change', function (event) {
  var select = event.target.closest('[data-variant-select]');
  if (!select) return;

  var form = select.closest('form');
  var price = form && form.querySelector('[data-variant-price]');
  var option = select.options[select.selectedIndex];

  if (price && option && option.dataset.price) {
    price.textContent = option.dataset.price;
  }
});

function applyCollectionFilter(scope, filter) {
  var chip = scope.querySelector('[data-filter-value="' + filter + '"]');
  if (!chip) return;

  var cards = scope.querySelectorAll('[data-product-card]');
  var count = 0;

  scope.querySelectorAll('[data-filter-value]').forEach(function (button) {
    var isActive = button === chip;
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });

  cards.forEach(function (card) {
    var terms = card.dataset.productFilter || '';
    var isVisible = filter === 'all' || terms.indexOf(filter) !== -1;
    card.hidden = !isVisible;
    if (isVisible) count += 1;
  });

  var countNode = scope.querySelector('[data-filter-count]');
  if (countNode) {
    countNode.textContent = filter === 'all' ? '' : count + ' shown';
  }
}

document.addEventListener('click', function (event) {
  var chip = event.target.closest('[data-filter-value]');
  if (!chip) return;

  var scope = chip.closest('[data-filter-scope]');
  if (!scope) return;

  applyCollectionFilter(scope, chip.dataset.filterValue);
  if (window.history && window.history.replaceState) {
    var url = new URL(window.location.href);
    if (chip.dataset.filterValue === 'all') {
      url.searchParams.delete('filter');
    } else {
      url.searchParams.set('filter', chip.dataset.filterValue);
    }
    window.history.replaceState({}, '', url.toString());
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var scope = document.querySelector('[data-filter-scope]');
  if (!scope) return;

  var params = new URLSearchParams(window.location.search);
  var filter = params.get('filter');
  if (filter) {
    applyCollectionFilter(scope, filter);
  }
});
